// extracted by mini-css-extract-plugin
export default {"container":"_K-z","dimension":"aL-z","dimensionLabels":"bL-z"};